"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = exports.requestedValue = exports.DomainTypes = exports.S = exports.ReturnTypeHelpers = exports.AggIntervalHelpers = void 0;
const zod_1 = __importDefault(require("zod"));
const Enums = __importStar(require("./generatedEnums"));
/* eslint-disable padding-line-between-statements */
exports.AggIntervalHelpers = __importStar(require("./_aggregation_helpers"));
exports.ReturnTypeHelpers = __importStar(require("./_return-type-helpers"));
exports.S = __importStar(require("./_settings"));
exports.DomainTypes = __importStar(require("./generatedTypes"));
/* eslint-enable padding-line-between-statements */
const aggIntervals = ['DAILY', 'HOURLY', 'UNAGGREGATED'];
const preferredAggregationInterval = 'preferredAggregationInterval';
exports.requestedValue = zod_1.default.object({
    [preferredAggregationInterval]: zod_1.default.enum(aggIntervals),
});
const propertiesRequestBy = zod_1.default.object({
    propertyIds: zod_1.default.array(zod_1.default.number()),
});
const blocksRequestBy = zod_1.default.object({
    blockIds: zod_1.default.array(zod_1.default.number()),
});
const pointsRequestBy = zod_1.default.object({
    lngLats: zod_1.default.array(zod_1.default.string()),
});
const regionsRequestBy = zod_1.default.object({
    regionIds: zod_1.default.string().array(),
});
const irrigationZoneRequestBy = zod_1.default.object({
    irrigationZoneIds: zod_1.default.array(zod_1.default.number()),
});
exports.requestSchema = zod_1.default.object({
    dateFrom: zod_1.default.string(),
    dateTo: zod_1.default.string(),
    includeSource: zod_1.default.boolean().optional(),
    blocks: blocksRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_Blocks, exports.requestedValue),
    }))
        .optional(),
    points: pointsRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_Points, exports.requestedValue),
    }))
        .optional(),
    irrigationZones: irrigationZoneRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_IrrigationZones, exports.requestedValue),
    }))
        .optional(),
    properties: propertiesRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_Properties, exports.requestedValue),
    }))
        .optional(),
    heatmapPoints: blocksRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_HeatmapPoints, exports.requestedValue),
    }))
        .optional(),
    regions: regionsRequestBy
        .merge(zod_1.default.object({
        valuesRequested: zod_1.default.record(Enums.ZEnumValuesValueTypes_Regions, exports.requestedValue),
    }))
        .optional(),
});
//# sourceMappingURL=index.js.map